import { render, staticRenderFns } from "./DynamicDashboard.vue?vue&type=template&id=fa32b68a&lang=pug&"
import script from "./DynamicDashboard.vue?vue&type=script&lang=ts&"
export * from "./DynamicDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicDashboard.vue?vue&type=style&index=0&id=fa32b68a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports